export const routes = [
  { 
    path: "yellow-zone", 
    label: "route.yellow-zone",
    inativityTime: 120
  },
  { 
    path: "green-zone", 
    label: "route.green-zone", 
    inativityTime: 120
  },
  { 
    path: "red-zone", 
    label: "route.red-zone", 
    inativityTime: 120
  },
  { 
    path: "lokker-type",
    label: "route.request-lokker",
    inativityTime: 30
  },
  { 
    path: "lokker-size",
    label: "route.request-lokker",
    inativityTime: 30
  },
  { 
    path: "lokker-assigned",
    label: "route.lokker-assigned",
    inativityTime: 10
  },
  { 
    path: "create-pin",
    label: "route.request-lokker",
    inativityTime: 30
  },
  { 
    path: "accessible-lokker",
    label: "route.request-lokker",
    inativityTime: 30
  },
  { 
    path: "access-my-lokkers",
    label: "route.my-lokkers",
    inativityTime: 20
  },
  { 
    path: "my-lokkers",
    label: "route.my-lokkers",
    inativityTime: 20
  },
  { 
    path: "release-lokker",
    label: "route.my-lokkers",
    inativityTime: 25
  },
  { 
    path: "lokker-released",
    label: "route.my-lokkers",
    inativityTime: 10
  },
  { 
    path: "lokker-opened",
    label: "route.my-lokkers",
    inativityTime: 10
  },
  { 
    path: "pick-and-collect",
    label: "route.pickNCollect",
    inativityTime: 15
  },
  { 
    path: "deposit-size",
    label: "route.depositObject",
    inativityTime: 15
  },
  { 
    path: "deposit-create-pin",
    label: "route.depositObject",
    inativityTime: 15
  },
  { 
    path: "deposit-confirm",
    label: "route.depositObject",
    inativityTime: 15
  },
  { 
    path: "deposit-lokker-opened",
    label: "route.depositObject",
    inativityTime: 15
  },
  { 
    path: "collect-access-pin",
    label: "route.collectObject",
    inativityTime: 15
  },
  { 
    path: "collect-object",
    label: "route.collectObject",
    inativityTime: 15
  },
  { 
    path: "recover-pin",
    label: "route.recoverPin",
    inativityTime: 25
  },
  { 
    path: "sms-sent",
    label: "route.recoverPin",
    inativityTime: 10
  },
  { 
    path: "terms-conditions",
    label: "route.terms-conditions",
    inativityTime: 30
  }
];

export const routerTransitionDelay = 1;
export const mobileBreakPoint = 768;
export const disabledOpacity = '0.3';
export const borderWidth = '8px';
export const borderWidthMobile = '2px';

export const backgroundImageExclusions = ['access-my-lokkers', 'create-pin', 'recover-pin', 'terms-conditions'];
